<template>
    <div class="sidebar" >
      <el-scrollbar style="height:100%;width:190px" :class="{active: collapse}">
        <el-menu class="sidebar-el-menu" :collapse="collapse" background-color="#283443" text-color="#fff" active-text-color="#20a0ff" router>
          <nav-bar-item v-for="(item, n) in items" :item="item" :navIndex="String(n)" :key="n"></nav-bar-item>
        </el-menu>
      </el-scrollbar>
    </div>
</template>

<script>
import { flat2 } from "@/utils";
import NavBarItem from "./SidebarItem";

export default {
  props: {
    collapse: {
      type: Boolean
    }
  },
  data() {
    return {
      // collapse: false,
      items: null
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    }
  },
  created() {
    this.getMemus();
  },
  methods: {
    getMemus() {
      this.$axios.get("/menus/top?recursion=true").then(res => {
        this.items = flat2(res.data.data);
      });
    }
  },
  components: { NavBarItem }
};
</script>

<style lang="scss">
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  // width: 190px;
  .active {
    width: 0px !important;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden !important;
    height: 100%;
  }
  .el-scrollbar__view {
    min-height: calc(100vh - 70px);
  }
  & > ul {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .el-menu--collapse {
    min-height: calc(100vh - 70px);
    width: 0px;
  }
  .sidebar-el-menu:not(.el-menu--collapse) {
    // width: 190px;
    min-height: calc(100vh - 70px);
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar.vue